export default ({ strokeColor = 'currentColor', size = 16, direction = 'right' }) => {
  const getTransform = () => {
    const center = size / 2;
    switch (direction) {
      case 'left':
        return `rotate(180)`;
      case 'up':
        return `rotate(-90 ${center} ${center})`;
      case 'down':
        return `rotate(90 ${center} ${center})`;
      case 'right':
      default:
        return '';
    }
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={getTransform()}
    >
      <path d="M2.11328 8.02881H12.7799" stroke={strokeColor} strokeWidth="1.33333" strokeLinecap="round"/>
      <path d="M10.1133 4.229L13.8845 8.00024L10.1133 11.7715" stroke={strokeColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};